export const MUSICNAME = "李氏神魔恋之Music Zone";
